import { Operator } from '../../../../../../../../services/common/Constants';
import React from 'react';
import EqualValue from './EqualValue';

const DateFormValue = ({ selectedOperator, showLabel, fieldName, readOnly = false }) => {
  switch (selectedOperator) {
    case Operator.EQUAL:
    case Operator.NOT_EQUAL:
    case Operator.GREATER_THAN:
    case Operator.GREATER_OR_EQUAL:
    case Operator.LESS_THAN:
    case Operator.LESS_OR_EQUAL:
      return <EqualValue showLabel={showLabel} fieldName={fieldName} readOnly={readOnly}/>;
    case Operator.BETWEEN:
      return <>{/*TODO*/}</>;
    case Operator.IS_NULL:
    case Operator.NOT_NULL:
      return <></>;
    case Operator.IN_SET:
    case Operator.NOT_IN_SET:
      return <>{/*TODO*/}</>;
    default:
      return <></>;
  }
};

export default DateFormValue;
